import './emailValidationCode.css';
import { useTutorUserRegistration } from 'context';
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import ReactInputVerificationCode from 'react-input-verification-code';
import { requiredMessage } from 'schemas/validators';

import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import theme from 'theme';

export const EmailValidationInput: React.FC = () => {
  const {
    form: { setValue, watch, clearErrors, setError },
  } = useTutorUserRegistration();

  const token = watch('token');

  useEffect(() => {
    clearErrors();
  }, [clearErrors]);

  return (
    <Controller
      name="token"
      rules={{
        required: requiredMessage('Código de validação'),
        minLength: {
          value: 6,
          message: requiredMessage('Código de validação'),
        },
      }}
      render={({ fieldState }) => {
        const handleChange = (value: string) => {
          setValue('token', value);
          setError('token', { message: undefined });
        };

        return (
          <>
            <Grid item xs={12} md={12}>
              <Typography
                color={
                  fieldState.error?.message
                    ? theme.palette.error.main
                    : '#7A8388'
                }
                fontSize={20}
                fontWeight={400}
              >
                Informe o código que você recebeu via e-mail
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} justifyContent="center">
              <Box
                className="custom-email-validation-styles"
                justifyContent="center"
                display="flex"
              >
                <ReactInputVerificationCode
                  value={token}
                  autoFocus
                  placeholder=""
                  length={6}
                  onChange={handleChange}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={12} justifyContent="center">
              <FormHelperText sx={{ textAlign: 'center' }} error>
                {fieldState.error?.message}
              </FormHelperText>

              <Typography
                color="#757575"
                fontSize={14}
                fontWeight={400}
                textAlign="center"
              >
                Expira em 1 hora.
              </Typography>
            </Grid>
          </>
        );
      }}
    />
  );
};
